"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _pageBaseBox = _interopRequireDefault(require("./page-base-box"));
_pageBaseBox.default.install = function (Vue) {
  Vue.component('z-page-base-box', _pageBaseBox.default);
};
var _default = _pageBaseBox.default;
exports.default = _default;